import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Paths } from '@/paths'
import { ErrorState } from '@/components/ErrorState'
import { usePageTitle } from '@/application/routing/hooks/usePageTitle'

export const ForbiddenPage: FC = () => {
  const { t } = useTranslation()

  usePageTitle(t('forbidden.pageTitle'))

  return <ErrorState title={t('forbidden.title')} description={t('forbidden.description')} buttonLabel={t('common.backToHome')} href={Paths.HOME} />
}
